import styled from "@emotion/styled";
import { Link, Outlet } from "react-router-dom";
import { Text } from "atoms";
import { NotificationToast } from "features/notifications";
import { Newsletter } from "./Newsletter";
import { SiteHeader } from "./SiteHeader";

function LayoutSite() {
  return (
    <>
      <SiteHeader />

      <SiteContent>
        <Outlet />
      </SiteContent>

      <Newsletter />

      <NotificationToast />

      <Footer>
        <TermsText size="xs">
          Some of the projects listed are a clients of HUG Studios, our advisory
          program which provides strategic guidance and mentorship to
          businesses.
        </TermsText>
        <TermsText size="xs">
          <Link to="/privacy-policy">Privacy Policy</Link>
          {" | "}
          <Link to="/terms-of-service">Terms of Service</Link>
        </TermsText>
        <TermsText size="xs">
          Copyright &copy; Assemble Stream, Inc. All rights reserved.
        </TermsText>
      </Footer>
    </>
  );
}
const SiteContent = styled.div({
  backgroundColor: "white",
});
const Footer = styled.footer(({ theme }) => ({
  background: [theme.colors.bg, theme.gradients.radial1],
  padding: theme.spacing.xl,
}));

const TermsText = styled(Text)({
  paddingBottom: ".5rem",
  textAlign: "center",
  maxWidth: "600px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block",
  a: {
    color: "currentColor",
    opacity: ".85",
    "&:hover, &:focus": {
      opacity: "1",
    },
  },
});

export { LayoutSite };
